<template>
  <div class="main-wrapper">
    <div>
      <layout-header></layout-header>
      <breadcrumb52></breadcrumb52>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar2></sidebar2>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <div class="container">
                <div class="col-12 ml-md-3">
                  <button class="new_btn btn btn-primary btn-sm" data-toggle="modal" @click="
                    $bvModal.show('add_new_doctor');
                  " href="">Add New Doctor</button>
                </div>
                <div class="form-group col-12 ml-md-3 mt-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Dr.</span>
                    </div>
                    <input type="text" v-model="doctorNameFilter" class="form-control"
                      placeholder="Search by Doctor's Name" />
                  </div>
                </div>
                <div class="row row-grid ml-md-3">
                  <div class="col-md-6 col-lg-4 col-xl-3" v-for="(item, $index) in filteredDoctors" :key="item.id"
                    v-show="setOpenReceipts($index)">
                    <div class="profile-widget text-center">
                      <!-- <i class="fas fa-star mt-2" style="color: #DAA520;float: right"></i> -->
                      <div class="doc-img">

                        <img class="img-fluid" style="height: 65px;width: 65px;" alt="User Image" v-bind:src="item.image
                          ? config.base_url_for_Image + item.image
                          : loadImg('Doctor Profile.svg')
                          " />

                      </div>
                      <div class="pro-content">
                        <h3 class="title">
                          {{ item.practitioner_name }}
                          <i class="fas fa-check-circle verified"></i>
                        </h3>
                        <p class="speciality">
                          {{ item.healthcare_practitioner_category }}
                        </p>

                        <ul class="available-info">
                          <li>
                            <i class="fas fa-map-marker-alt"></i>{{ item.city }}
                            {{ item.suburb ? "," + item.suburb : "" }}
                          </li>
                          <li v-if="item.total_experience_in_years == 0">
                            -
                          </li>
                          <li v-else>
                            <i class="fas fa-history"></i>{{ item.total_experience_in_years }}
                          </li>
                        </ul>
                        <div class="row row-sm">
                          <div class="col-12 text-center">
                            <router-link class="btn view-btn" :to="{
                              name: 'doctor-profile',
                              params: { name: item.name },
                            }">Profile</router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h5 v-if="favourite.length === 0 && !showspinner" style="margin-left: -8%" class="No_data">
                  No Doctor Found
                </h5>
                <div class="row justify-content-center" v-if="favourite.length > 12">
                <div>
                <h5 class="" style="color: #8d8c8c;">Total Doctors : {{ total_doctors }}</h5>
              </div>
              </div>
                <!-- pagination  -->
                <div id="pagination" v-if="favourite.length > 8">
                  <ul class="pagination justify-content-center">

                    <!-- "Previous" Button -->
                    <li class="page-item" :class="receipt_current === 1 ? 'disabled' : ''">
                      <a href="#" class="page-link" aria-label="Previous"
                        @click.prevent="updateReceiptCurrent(receipt_current - 1)">
                        Previous
                      </a>
                    </li>

                    <!-- Pagination Links (Display 5 at a time) -->
                    <li v-for="page_index in receipt_paginate_total" :key="page_index.id" :class="[
                      'page-item',
                      receipt_current === page_index ? 'active' : ''
                    ]" v-if="page_index >= receipt_current - 2 && page_index <= receipt_current + 2">
                      <a href="#" class="page-link" @click.prevent="updateReceiptCurrent(page_index)">
                        {{ page_index }}
                      </a>
                    </li>

                    <!-- "Next" Button -->
                    <li class="page-item" :class="receipt_current === receipt_paginate_total ? 'disabled' : ''
                      ">
                      <a href="#" class="page-link" aria-label="Next"
                        @click.prevent="updateReceiptCurrent(receipt_current + 1)">
                        Next
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
    <!-- new patient add modal -->
    <div>
      <b-modal id="add_new_doctor" hide-footer>
        <!-- <template #modal-title> -->
        <template #modal-title>
          <h3 class="modal-title">Add New Doctor</h3>
        </template>
        <div class="d-block text-center">
          <div class="card">
            <div class="card-body">
              <div class="modal-body">

                <form @submit.prevent="submit_doctor" class="row form-row" v-if="!showOtpInput">
                  <div class="col-12 col-md-6">
                    <div class="input-group form-group">
                      <div class="input-group-prepend">
                        <div class="input-group-text">Dr.</div>
                      </div>
                      <input type="text" name="first_name" required class="form-control" placeholder="First Name"
                        v-model="register_doctor.first_name"
                        oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '');" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input type="text" name="last_name" required class="form-control floating"
                        v-model="register_doctor.last_name" placeholder="Last Name"
                        oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '');" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input type="email" required v-model="register_doctor.email" class="form-control floating"
                        placeholder="Email" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group" style="position: relative;">
                      <button class="btn btn-default" type="button"
                        style="position: absolute; left: 0; top: 0; border: 1px solid #ccc; border-right: none; background-color: lightgrey; height: 40px; border-radius: 4px 0 0 4px; z-index: 2;">91</button>
                      <input type="text" required maxlength="10" minlength="10" @keypress="onlyNumber"
                        @keydown.enter="sendOtpOnEnter" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        style="padding-left: 60px; padding-top: 10px; padding-bottom: 10px; border-radius: 4px; letter-spacing: 2px;"
                        v-model="register_doctor.doctor_mobile_no" class="form-control floating"
                        placeholder="Mobile Number" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <v-select name="city" required="" label="city" placeholder="Select City"
                        v-model="register_doctor.city" :reduce="(option) => option.city" :options="cities">
                      </v-select>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <v-select label="sub_category_name" placeholder="Select Practitioner Category"
                        v-model="register_doctor.healthcare_practitioner_category"
                        :reduce="(option) => option.sub_category_name" :options="healthcare_practitioner_categories"
                        required>
                      </v-select>
                    </div>
                  </div>
                  <div>
                    <div class="text-center mt-1">
                      <div class="submit-section text-left">
                        <button ref="sendOtpButton" class="btn btn-primary login-btn" type="submit" :disabled="isDisabled"
                          @click="submit_doctor">
                          Send OTP
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="col-md-12 col-lg-12" v-else>
                  <div class="login-header">
                    <h3 class="text-center">Enter OTP</h3>
                    <!-- <p class="small text-muted">Enter your OTP No</p> -->
                  </div>

                  <!-- Forgot Password Form -->
                  <div id="app">
                    <div class="otp-container">
                      <input v-for="(value, index) in otpValues" :key="index" type="text" maxlength="1" class="otp-input"
                        :value="value" @input="handleInput(index, $event.target.value)"
                        @keydown.backspace="handleBackspace(index)" ref="otpFields" @keypress="onlyNumber"
                        @keydown.enter.prevent="verify_OTP()" pattern="[0-9]*" autofocus />
                    </div>
                  </div>
                  <div class="mt-5">
                    <button ref="verifyOtpButton" class="btn btn-primary login-btn" type="submit" @click="verify_OTP()">
                      Verify OTP
                    </button>
                  </div>
                  <!-- /Forgot Password Form -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- new patient add modal end -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from 'vue-multiselect'
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
const images = require.context("@/assets/img/doctors");
import axios from "axios";
export default {
  components: {
    Multiselect, // Add this line to register the component
  },

  data() {
    return {
      otpValues: ["", "", "", "", "", ""],
      cities: [],
      doctorNameFilter: "",
      favourite: [],
      total_doctors: 0,
      showspinner: true,
      config: config,
      token: localStorage.getItem(JSON.stringify("Authorization")),
      receipt_current: 1,
      receipt_paginate: 8,
      receipt_paginate_total: 0,
      healthcare_practitioner_categories: [],
      register_doctor: {
        first_name: "",
        last_name: "",
        email: "",
        doctor_mobile_no: "",
        city: "",
        healthcare_practitioner_category: "",
      },
      showOtpInput: false,
      hospitalName: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).hospital
        : '',
      hospitalCity: localStorage.getItem("hospitalID")
        ? JSON.parse(localStorage.getItem("hospitalID")).city
        : '',
    };
  },

  watch: {
    register_doctor: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  computed: {
    isOtpValid() {
      return this.otp.every((digit) => /\d/.test(digit)); // Check if all digits are numbers
    },
    isDisabled() {
      // Check if all required fields are filled, including city
      return (
        !this.register_doctor.first_name ||
        !this.register_doctor.last_name ||
        !this.register_doctor.email ||
        !this.register_doctor.doctor_mobile_no ||
        !this.register_doctor.city || // Include city in the check
        !this.register_doctor.healthcare_practitioner_category
      );
    },
    filteredDoctors() {
      return this.favourite.filter((item) =>
        item.practitioner_name.toLowerCase().includes(this.doctorNameFilter.toLowerCase())
      );
    },
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_cities();
    this.get_healthcare_categories();
    this.get_my_doctors();
  },

  methods: {

    verify_OTP() {
      const fullOtp = this.otpValues.join("");
      var bodyFormData = new FormData();
      bodyFormData.append("phone", this.register_doctor.doctor_mobile_no);
      bodyFormData.append("otp", fullOtp);

      CommonApi.post_data("sahaj.api.verify_otp_code", bodyFormData, true).then((res) => {
        if (res.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
          });
          this.register_new_Doctor();
        } else {
          // OTP verification failed
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });

    },

    handleInput(index, value) {
      if (value.length > 1) {
        return;
      }
      this.otpValues[index] = value;
      if (value.length === 1 && index < this.otpValues.length - 1) {
        this.$refs.otpFields[index + 1].focus();
      }
    },
    handleBackspace(index) {
      if (this.otpValues[index] !== "") {
        this.otpValues[index] = "";
      } else if (index > 0) {
        this.$refs.otpFields[index - 1].focus();
      }
    },

    validateForm() {
      if (
        this.register_doctor.healthcare_practitioner_category === "" ||
        this.register_doctor.healthcare_practitioner_category === null
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },

    sendOtpOnEnter(event) {
      if (event.key === "Enter" && !this.disabled) {
        this.$refs.sendOtpButton.click();
      }
    },

    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    async get_cities() {
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.cities = res.message;
      });
    },

    /* Get Healthcare Categories */
    async get_healthcare_categories() {
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_sub_categories"
      ).then((res) => {
        if (res.status_code == 200) {
          this.healthcare_practitioner_categories = res.data;
        }
      });
    },

    register_new_Doctor() {
      this.$swal({
        text: "Creating your account",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        first_name: this.register_doctor.first_name,
        last_name: this.register_doctor.last_name,
        email: this.register_doctor.email,
        mobile_no: this.register_doctor.doctor_mobile_no,
        city: this.register_doctor.city,
        healthcare_practitioner_category: this.register_doctor.healthcare_practitioner_category,
        hospital: this.hospitalName,
        hospital_city: this.hospitalCity

      };
      CommonApi.post_data("sahaj.hospital.register_doctor", data, true).then(
        (res) => {
          if (res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        }
      );
    },



    async submit_doctor() {
      if (this.register_doctor) {
        this.$swal({
          text: "Sending OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.register_doctor.doctor_mobile_no);
        for (const key in this.register_doctor) {
          if (this.register_doctor.hasOwnProperty(key)) {
            bodyFormData.append(key, this.register_doctor[key]);
          }
        }

        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (res.status_code == 200) {
              this.showOtpInput = true;
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
              });
              setTimeout(() => {
                this.$swal.close();
              }, 1000);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
          }
        );
      }
    },


    // pagination start
    setOpenReceipts(i) {
      if (this.receipt_current == 1) {
        return i < this.receipt_paginate;
      } else {
        return (
          i >= this.receipt_paginate * (this.receipt_current - 1) &&
          i < this.receipt_current * this.receipt_paginate
        );
      }
    },

    updateReceiptCurrent(i) {
      this.receipt_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    /* Get My Doctors  */
    async get_my_doctors() {
      const params = new URLSearchParams();
      params.append("hospital", "Ramsnehi Hospital-Bhilwara");
      await CommonApi.get_data("sahaj.hospital.get_hospital_doctor", params).then(
        (res) => {
          this.showspinner = false;
          if (res && res.data) {
             this.total_doctors = res.data.count;
            this.favourite = res.data.doctor_list.filter((data) => data.is_favorite !== 0);
            this.receipt_paginate_total = Math.ceil(
              this.favourite.length / this.receipt_paginate
            );
          }
        }
      );
    },

  },
};
</script>
<style scoped>
body {
  height: 100%;
  width: 100%;
  background-color: #333;
}

.opt {
  text-align: center;
  letter-spacing: 15px;
}

#countdown {
  position: relative;
  margin: auto;
  margin-top: 8px;
  height: 40px;
  width: 40px;
  text-align: center;
}

#countdown-number {
  color: black;
  display: inline-block;
  line-height: 40px;
}

svg {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  transform: rotateY(-180deg) rotateZ(-90deg);
}

svg circle {
  stroke-dasharray: 113px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  stroke-width: 2px;
  stroke: red;
  fill: none;
  animation: countdown 60s linear forwards;
}

.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  margin: 0 10px;
  border: none;
  border-bottom: 2px solid #403636;
  box-shadow: none;
  background-color: transparent;
  color: #140b0b;
  transition: all 0.3s ease-in-out;
  font-family: Arial, Helvetica, sans-serif;
}

.otp-input:focus {
  outline: none;
  border-bottom: 2px solid #09e5ab;
}

.new_btn:hover {
  background-color: #008080;
}

@keyframes countdown {
  from {
    stroke-dashoffset: 0px;
  }

  to {
    stroke-dashoffset: 113px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/hospital/Doctors.vue